import React, { useState, useEffect, useMemo, useRef } from 'react'
import { ContentHeader, Loader } from '@components';
import { Link, useLocation } from 'react-router-dom'
import moment from 'moment';
import { TableHeader, Pagination, Search } from '@app/components/react-data-table';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { getUserData, deleteUser } from '../../services/users';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';

const Users = () => {
    const user = useSelector((state: any) => state.auth.currentUser);
    const [listData, setListData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const { pathname } = useLocation();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "", type: "" });
    const ITEMS_PER_PAGE = 25;
    const componentRef = useRef();

    const getList = (filter = "") => {
        setLoading(true);
        getUserData(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.records) {
                let data: any = [];
                resp.records.map((val: any, i: any) => {
                    data[i] = {
                        id: val.id,
                        name: val.name,
                        email: val.email,
                        role: val.role,
                        last_activity: val.last_activity ? moment(val.last_activity).fromNow() : '',
                        portals_name: val.portals_name,
                        portals_ids: val.portals_ids,
                        created_at: moment(val.created_at).format('MM/DD/YYYY'),
                        created_by: val.created_by ? val.created_by : 'System'
                    };
                });

                if (resp.allRowTotal) {
                    data['total'] = resp.allRowTotal;
                }

                setListData(data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            return false;
        });
    };

    const colomns = [
        { name: "Name", field: "name", sortable: true },
        { name: "Email", field: "email", sortable: false, type: "number" },
        { name: "Role", field: "role", sortable: true },
        { name: "Portal", field: "portals", sortable: false },
        { name: "Last Activity", field: "last_activity", sortable: true },
        { name: "Action", sortable: false, className: 'td-center d-print-none' }
    ];

    const resultData = useMemo(() => {
        let computedResults = listData;
        if (search) {
            computedResults = computedResults.filter(
                data => data.name.toLowerCase().includes(search.toLowerCase()) || data.email.toLowerCase().includes(search.toLowerCase())
            );
        }
        setTotalItems(computedResults.length);
        //Sorting listData
        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            if (sorting.type && sorting.type == 'number') {
                computedResults = computedResults.sort((a, b) => reversed * a[sorting.field].replace(",", "") - b[sorting.field].replace(",", ""));
            } else {
                computedResults = computedResults.sort((a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]));
            }
        }
        //Current Page slice
        return computedResults.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [listData, currentPage, search, sorting]);


    useEffect(() => {
        setSearch("");
        getList();
    }, [pathname])


    const deleteItem = (paramId: number) => {
        confirmAlert({
            message: 'Are you sure you want to delete this user?',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    setLoading(true);
                    deleteUser(paramId).then((result: any) => {
                        setLoading(false);
                        if (result.data.Acknowledge == '1') {
                            getList();
                            toast.success('User has been deleted successfully.');
                        } else if (result.data.FullMessage != "") {
                            setLoading(false);
                            toast.error(result.data.FullMessage);
                        }
                    }).catch((err) => {
                        setLoading(false);
                        toast.error("Internal server error on delete.");
                    });
                }

            },
            {
                label: 'No',
            }]
        });
    }
    return (
        <>
            <ContentHeader title="Manage Users" />
            <section className="content">
                <div className="container-fluid">
                    <div className="col-12">
                        <div className="card order_listing">
                            <div className="card-body">
                                <div className='table-warp-search-pagination'>
                                    <div className='d-flex custom-pagination justify-content-between'>
                                        <Search
                                            onSearch={value => {
                                                setSearch(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                        <Link to="/users/add" className="btn btn-primary btn_new_order btn_txt">
                                            Add New User
                                        </Link>
                                    </div>
                                    <div className='listing_table_wrap large_table_wrap' ref={componentRef}>
                                        <h3 className='d-none d-print-block m-2'>Users Listing</h3>
                                        <table className="cell-border table table-bordered table-striped" style={{ width: '100%' }} >
                                            <TableHeader
                                                headers={colomns}
                                                onSorting={(field, order, type) =>
                                                    setSorting({ field, order, type })
                                                }
                                            />
                                            <tbody>
                                                {resultData.length > 0 ? resultData.map((row: any, podidx) => (
                                                    <tr className='tr-center' key={podidx}>
                                                        <td>{row.name}</td>
                                                        <td>{row.email}</td>
                                                        <td>{row.role}</td>
                                                        <td> {row.portals_name.map((val: any, i: any) => (
                                                            <Link to={{ pathname: `/users/manage-permission/${row.id}/${row.portals_ids[i]}` }} title="Give Permission"><span className="badge badge-danger">{val}</span></Link>
                                                        ))}
                                                        </td>
                                                        <td>{row.last_activity}</td>
                                                        <td className='td-center d-print-none'>
                                                            <Link className="btn edit_btn p-0 pr-2" to={{ pathname: `/users/manage-sites/${row.id}` }} title="Give Permission"><i className="nav-icon fa fa-user-lock"></i></Link>
                                                            <Link className="btn edit_btn p-0 pr-2" to={{ pathname: `/users/edit/${row.id}` }} title="Edit"><i className="nav-icon far fa-edit"></i></Link>
                                                            <button onClick={() => deleteItem(row.id)} title="Delete" className="btn delete_btn p-0"><i className="nav-icon far fa-trash-alt"></i></button>
                                                        </td>
                                                    </tr>
                                                ))
                                                    : <tr><td style={{ textAlign: 'center' }} colSpan="6">No record found.</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        total={totalItems}
                                        itemsPerPage={ITEMS_PER_PAGE}
                                        currentPage={currentPage}
                                        onPageChange={page => setCurrentPage(page)}
                                    />
                                </div>
                            </div>
                            <Loader isLoading={isLoading} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Users;
